// Identidade "Azul aço" do MedStation (paleta do designer Fransel; tokens e contraste
// em docs/marca/tokens.json e docs/marca/DESIGN.md).
const colors = {
  // Aço — primária. 500 = #234E70; 600 hover, 700 active; 50/100 fundos sutis.
  brand: {
    50: "#EEF3F8",
    100: "#D6E3EE",
    200: "#AEC6DB",
    300: "#7FA3C2",
    400: "#4F7A9E",
    500: "#234E70",
    600: "#1C4160",
    700: "#16344E",
    800: "#10273B",
    900: "#0B1B29",
  },
  // Apoio — secundária. 300 = #8AB6D6 (só fundo/decorativo: branco sobre ele não passa AA);
  // texto em 600/700. O nome "teal" é histórico (era verde-água); os tokens accent-* em
  // semanticTokens são o tom da marca (brand), não esta escala.
  teal: {
    50: "#F1F7FB",
    100: "#E0EDF6",
    200: "#C3DCEC",
    300: "#8AB6D6",
    400: "#6A9DC3",
    500: "#4B83AE",
    600: "#366A93",
    700: "#295677",
    800: "#1E4159",
    900: "#142C3D",
  },
  success: {
    50: "#E8F5EC",
    100: "#C8ECD2",
    300: "#5CBF76",
    500: "#16A34A",
    600: "#15803D",
    700: "#166534",
  },
  warning: {
    50: "#FDF4E3",
    100: "#FBE6B0",
    300: "#E2AD2A",
    500: "#CA8A04",
    600: "#B45309",
    700: "#8A3F06",
  },
  danger: {
    50: "#FDECEC",
    100: "#F9C6C6",
    300: "#F37474",
    500: "#E53E3E",
    600: "#C81E1E",
    700: "#A51B1B",
  },
};

export default colors;
